import { useLazyQuery, gql } from '@apollo/client';
export const NORMALIZE_ADDRESS = gql `
  query normalizedAddress($input: AddressInput!) {
    normalizedAddress(input: $input) {
      normalizedAddress {
        unit
        street
        city
        state
        postalCode
        components
        analysis
        metadata
        status
        classification
      }
    }
  }
`;
/**
 * Creates a lazy query to request normalization of an address
 * @returns Apollo Lazy Query hook for the normalized address query
 */
export function useNormalizedAddressQuery() {
    return useLazyQuery(NORMALIZE_ADDRESS);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlLWFkZHJlc3Mtbm9ybWFsaXphdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZGRyZXNzL3VzZS1hZGRyZXNzLW5vcm1hbGl6YXRpb24vdXNlLWFkZHJlc3Mtbm9ybWFsaXphdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsWUFBWSxFQUFFLEdBQUcsRUFBRSxNQUFNLGdCQUFnQixDQUFDO0FBR25ELE1BQU0sQ0FBQyxNQUFNLGlCQUFpQixHQUFHLEdBQUcsQ0FBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Q0FpQm5DLENBQUM7QUFZRjs7O0dBR0c7QUFDSCxNQUFNLFVBQVUseUJBQXlCO0lBQ3ZDLE9BQU8sWUFBWSxDQUNqQixpQkFBaUIsQ0FDbEIsQ0FBQztBQUNKLENBQUMifQ==